import { Phone, Mail, MapPin, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

function normalizePhoneToWa(phone) {
  const raw = String(phone || '').trim();
  if (!raw) return null;
  const digits = raw.replace(/\D/g, '');
  const wa = digits.startsWith('55') ? digits : `55${digits}`;
  if (wa.length < 12) return null;
  return wa;
}

const CTASection = ({ siteConfig, slug }) => {
  const nome = siteConfig?.nome || siteConfig?.displayName || 'Corretor';

  const waNumber = normalizePhoneToWa(siteConfig?.whatsapp);
  const waHref = waNumber
    ? `https://wa.me/${waNumber}?text=${encodeURIComponent(
        `Olá ${nome}! Vim pelo seu site e gostaria de falar com você.`
      )}`
    : null;

  const email = siteConfig?.email || siteConfig?.mail || '';
  const enderecoLinha1 =
    siteConfig?.enderecoLinha1 || siteConfig?.endereco || '';
  const enderecoLinha2 = siteConfig?.enderecoLinha2 || '';

  return (
    <section id="contato" className="py-24 lg:py-32 bg-cream">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <p className="text-gold font-medium tracking-wider text-sm uppercase">
                Vamos Conversar
              </p>
              <h2 className="font-serif text-4xl lg:text-5xl font-semibold text-foreground leading-tight">
                Vamos encontrar o imóvel ideal?
              </h2>
              <p className="text-muted-foreground text-lg leading-relaxed max-w-lg">
                Fale comigo e eu te ajudo a comprar, vender ou anunciar com
                estratégia.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              {waHref ? (
                <a href={waHref} target="_blank" rel="noreferrer">
                  <Button variant="gold" size="xl" className="group gap-2">
                    <Phone className="w-5 h-5" />
                    Falar no WhatsApp
                  </Button>
                </a>
              ) : (
                <Button
                  variant="gold"
                  size="xl"
                  className="group gap-2"
                  disabled
                >
                  <Phone className="w-5 h-5" />
                  WhatsApp
                </Button>
              )}

              <Button
                variant="heroOutline"
                size="xl"
                className="group"
                onClick={() => {
                  const target = `/site/${slug}/imoveis`;
                  window.location.assign(target);
                }}
              >
                Ver Imóveis
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </div>
          </div>

          {/* Contact Info */}
          <div className="space-y-6">
            <div className="p-6 bg-card rounded-xl border border-border shadow-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center shrink-0">
                  <Phone className="w-6 h-6 text-gold" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Telefone / WhatsApp
                  </h3>
                  <p className="text-muted-foreground">
                    {siteConfig?.whatsapp || '—'}
                  </p>
                  <p className="text-sm text-muted-foreground mt-1">
                    Atendimento conforme disponibilidade.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6 bg-card rounded-xl border border-border shadow-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center shrink-0">
                  <Mail className="w-6 h-6 text-gold" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">E-mail</h3>
                  <p className="text-muted-foreground">{email || '—'}</p>
                  <p className="text-sm text-muted-foreground mt-1">
                    Resposta assim que possível.
                  </p>
                </div>
              </div>
            </div>

            <div className="p-6 bg-card rounded-xl border border-border shadow-card">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-gold/10 rounded-lg flex items-center justify-center shrink-0">
                  <MapPin className="w-6 h-6 text-gold" />
                </div>
                <div>
                  <h3 className="font-semibold text-foreground mb-1">
                    Localização
                  </h3>
                  <p className="text-muted-foreground">
                    {enderecoLinha1 || '—'}
                  </p>
                  {enderecoLinha2 ? (
                    <p className="text-muted-foreground">{enderecoLinha2}</p>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
